import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { BlankButton } from 'modules/UI';

export const Container = styled.div`
  margin-bottom: 30px;
  max-width: 610px;
`;

export const Header = styled.div`
  background-color: #eaeaea;
  height: 32px;
`;

export const Body = styled.div`
  color: #333;

  pre {
    margin: 0;
  }
`;

export const LanguageList = styled.ul`
  display: flex;
  padding: 0;
  padding-left: 18px;
  margin: 0;
`;

type LanguageProps = {
  active: boolean;
};

export const Language = styled(BlankButton)<LanguageProps>`
  font-family: ${tokens.font.family.ifood.body};
  font-size: 13px;
  padding: 3px 13px;
  font-weight: 400;
  background-color: #eaeaea;

  &:hover {
    background-color: #e2e1e1;
    color: #777;
  }

  ${({ active = false }): string | false =>
    active &&
    `
    font-weight: 600;
    color: #333;
  `}
`;
